import { Box, BoxProps, styled } from '@mui/material';

export const FilterTagContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  padding: '0.5rem 1rem',
  alignItems: 'center',
  gap: '0.5rem',
  backgroundColor: theme.palette.monochrome.monoChrome1,
  borderRadius: '1.5rem',
  fontSize: '1.125rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '1.125rem',
  color: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.monochrome.monoChrome6}`,
}));

export const ClearAllTagsContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  padding: '0.5rem 1rem',
  alignItems: 'center',
  fontSize: '1.125rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '1.125rem',
  color: theme.palette.secondary.main,
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const FilterTagsList = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
}));

export const FiltersBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: theme.palette.monochrome.monoChrome2,
  padding: '1.5rem',
  borderRadius: '6px',
  marginBottom: '1rem',
}));
